module.exports = __webpack_public_path__ + "static/media/Inter-Black.e11ae720.woff2";